import React from "react";
import { history } from "../store";

function OutBoundBanner(props) {
  const {redirection_link, message, status} = JSON.parse(props.outBoundBannerData[0].settings);

  return status && status.value === 1 ? (
    <div className="sc-warning" style={{ padding: '10px 24px',height: 'auto', background: '#FEF6E7', borderRadius: '5px', border: 'none', width: 'auto' }}>
      <div>{message && message.value}</div>
      <span style={{ color: '#0375D9', fontWeight: 600, cursor: 'pointer'}} onClick={() => { history.push(redirection_link && redirection_link.value) }}>
        <i
          className="fa fa-exclamation-circle"
          style={{color: '#0375D9', fontSize: 13, marginRight: '5px' }}
        />
        Learn more.
      </span>
    </div>
  ) : null
}
export default OutBoundBanner;


/** WEBPACK FOOTER **
 ** ./src/components/OutBoundBanner.js
 **/